import { useState } from "react";
import { KEYS } from "@/lib/storage-keys";

const THEME_STORAGE_KEY = KEYS.theme;

/**
 * Le pagine pubbliche pre-login (Landing, Accedi, verifica email, recupero
 * password) condividono la stessa base visiva "da sito vetrina"
 * (`startup-bg`, card chiare traslucide) e devono restare tutte coerenti tra
 * loro finché l'utente non ha scelto esplicitamente un tema (Scuro/Sistema,
 * persistito da next-themes su `aiposto:theme`, gestito dall'Aspetto in
 * dashboard).
 *
 * Bug corretto: `ThemeProvider` usa `defaultTheme="system"` — su un browser
 * con preferenza Scuro, senza questo hook ogni pagina pubblica risolve da
 * sola il tema `.dark` ereditato da `<html>`. Se solo alcune lo forzano
 * chiaro (com'era prima per la sola Landing) e altre no, la navigazione tra
 * pagine pubbliche cambia tema in modo visibile e incoerente (es. Landing
 * chiara -> Accedi scura) — un errore di UX visibile ancora prima del login.
 *
 * Va applicato dalla stessa pagina radice di TUTTE le pagine pubbliche:
 * la classe restituita (`public-force-light`, vedi index.css) va sempre
 * unita alle classi esistenti del contenitore radice.
 */
export function usePublicPageForceLightClass() {
  const [forceLight] = useState(() => {
    try {
      return !["light", "dark", "system"].includes(window.localStorage.getItem(THEME_STORAGE_KEY));
    } catch {
      return true;
    }
  });
  return forceLight ? "public-force-light" : "";
}
